import { motion } from "framer-motion";

export default function DashboardSkeleton() {
    return (
        <div className="min-h-[calc(100vh-60px)] px-4 pt-6 pb-10 bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800 transition-colors duration-300">
            <div className="max-w-7xl mx-auto space-y-8">

                {/* Header Skeleton */}
                <div className="space-y-2">
                    <div className="h-8 w-64 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
                    <div className="h-4 w-48 bg-gray-100 dark:bg-gray-800 rounded animate-pulse" />
                </div>

                {/* Banner Skeleton */}
                <div className="h-32 w-full bg-gray-200 dark:bg-gray-800 rounded-2xl animate-pulse" />

                {/* Main Grid Skeleton */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    {/* Left Col */}
                    <div className="lg:col-span-1 space-y-6">
                        <div className="h-48 bg-gray-200 dark:bg-gray-800 rounded-xl animate-pulse" />
                        <div className="h-48 bg-gray-200 dark:bg-gray-800 rounded-xl animate-pulse" />
                    </div>

                    {/* Right Col */}
                    <div className="lg:col-span-2 space-y-6">
                        <div className="h-96 bg-gray-200 dark:bg-gray-800 rounded-xl animate-pulse" />
                        <div className="grid grid-cols-2 gap-6">
                            <div className="h-40 bg-gray-200 dark:bg-gray-800 rounded-xl animate-pulse" />
                            <div className="h-40 bg-gray-200 dark:bg-gray-800 rounded-xl animate-pulse" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
